export default "__VITE_ASSET__BhrzvHY1__"